import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import home from '../../assets/home.png';
import PTLEHoverFeature from '../../assets/PTImages/PTLEHoverFeature.png';
import PTPayrollCCExpanded from '../../assets/PTImages/PTPayrollCCExpanded.png';
import PTManagerWWIDPopulated from '../../assets/PTImages/PTManagerWWIDPopulated.png';
import PTLocationSearch from '../../assets/PTImages/PTLocationSearch.png';
import PTLocationPopup from '../../assets/PTImages/PTLocationPopup.png';
import PTHeadcountPopup from '../../assets/PTImages/PTHeadcountPopup.png';

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
class FrequentlyAsked extends Component{

    constructor(props) {
        super(props);
        this.state={
            windowheight: 0,
            fwdLatestRefreshDate : '',
            locationLatestRefreshDate: '',
            r360LatestRefreshDate: ''
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        axios({
            method: 'GET',
            url: process.env.REACT_APP_WORKDAY_API_URL +'getConfigDetails',
            headers: {
                'apiKey': process.env.REACT_APP_WORKDAY_API_KEY,
                'clientKey': process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }).then((res)=>{
            //console.log(res.data.allConfig);
            var configData = res.data.allConfig;
            for(var i=0;i<configData.length;i++){
                if(configData[i].config_key == 'fdw_service_last_run_date'){
                    var fdwRes = configData[i].config_value;
                    var date = new Date(fdwRes);
                    
                    var fdwData = months[date.getMonth()]+' '+date.getDate()+', '+date.getFullYear();

                } 
                if(configData[i].config_key == 'location_sync_service_last_run_date'){
                    var locationRes = configData[i].config_value;
                    var date = new Date(locationRes);
                   
                    var locationData = months[date.getMonth()]+' '+date.getDate()+', '+date.getFullYear();
                } 
                if(configData[i].config_key == 'r360_prefix_sync_service_last_run_date'){
                    var r360Res = configData[i].config_value;
                    var date = new Date(r360Res);
                    
                    var r360Data = months[date.getMonth()]+' '+date.getDate()+', '+date.getFullYear();
                }  
            }
            this.setState({
                fwdLatestRefreshDate: fdwData,
                locationLatestRefreshDate : locationData,
                r360LatestRefreshDate : r360Data
            });
        }).catch((error) =>{
            //alert('Error with config calling API');
        });
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
      updateWindowDimensions = () => {
        this.setState({ windowheight: window.innerHeight - this.Dimension("headercontent") - this.Dimension("footercontent") });
      }
      Dimension = (elmID) => {
        var elmHeight, elmMargin, elm = document.getElementsByClassName(elmID)[0];
        if (document.all) {// IE
          elmHeight = elm.clientHeight;
          elmMargin = parseInt(elm.currentStyle.marginTop, 10) + parseInt(elm.currentStyle.marginBottom, 10);
        } else {// Mozilla
          elmHeight = elm.clientHeight;
          elmMargin = parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-bottom'));
        }
        return (elmHeight + elmMargin + 6);
      }
      render(){
          return(
            <div className="contentbody">
                <div className='some-page-wrapper' style={{ minHeight: + this.state.windowheight }}>
                    <div className="frequentlyAskedMain">
                        <h2 style={{display:"inline"}}><b>Frequently Asked Questions (FAQs)</b></h2>
                        <Link to="/"><img className="homeicon" src={home}/></Link>
                        <ul className="frequentlyAskedBullet">
                        <a href="#Question1" className="faqQuestionLink"><li> What information do I need to use the tool?</li></a>
                            <a href="#Question2" className="faqQuestionLink"><li> What browser do I need to access the tool?</li></a>
                            <a href="#Question3" className="faqQuestionLink"><li> Why does the hiring manager’s location not match with their physical location?</li></a>
                            <a href="#Question4" className="faqQuestionLink"><li> Is the Hiring Manager’s Location the same as the J&J site location associated with position?</li></a>
                            <a href="#Question5" className="faqQuestionLink"><li> When was the data used by the tool last refreshed? </li></a>
                            <a href="#Question6" className="faqQuestionLink"><li> How often is the data in the tool updated?</li></a>
                            <a href="#Question7" className="faqQuestionLink"><li> Who can receive the Predictor Tool results via email?</li></a>
                            <a href="#Question8" className="faqQuestionLink"><li>What is the difference between Payroll and Headcount MRC and Cost Center?</li></a>
                            <a href="#Question9" className="faqQuestionLink"><li> Helpful hints and features for selecting legal entity (LE) and cost center (CC).</li></a>
                            <a href="#Question10" className="faqQuestionLink"><li> Predictor Tool pop-up descriptions. </li></a>
                        </ul>
                        {/* Question1 */}
                        <a id="Question1" className="faqQuestionHeader"><b>What information do I need to use the tool?</b></a>
                        <p>Required information: </p>
                        <ul>
                            <li>Hiring Manager’s WWID</li>
                            <li>J&J site location associated with position</li>
                                <ul>
                                    <li>Once you input the Hiring Manager WWID the tool will provide you with the location on file in Workday for that manager.</li>
                                </ul>
                            <li>Optional: email addresses to which prediction will be sent.</li>
                        </ul>

                        {/* Question2 */}
                        <a id="Question2" className="faqQuestionHeader"><b>What browser do I need to access the tool?</b></a>
                        <p>The recommended browser for using the tool is Google Chrome.<br/>
                        Please note that if you are logged into the J&J network you will be able to access the link via Single Sign-On (SSO).</p>

                        {/* Question3 */}
                        <a id="Question3" className="faqQuestionHeader"><b>Why does the hiring manager’s location not match with their physical location?</b></a>
                        <p>In some instances, the Hiring Manager’s physical location may not match with the location listed by the tool because the tool pulls the manager’s location from Workday. For example, a manager’s physical address could be 410 George Street in New Brunswick, but in Workday their location is listed as 1 J&J Plaza which is also in New Brunswick. This isn’t necessarily an error it’s simply the location on file. </p>

                        {/* Question4 */}
                        <p id="Question4" className="faqQuestionHeader"><b>Is the Hiring Manager’s Location the same as the J&J site location associated with position?</b></p>
                        <p>They could be the same if the manager is trying to fill a position at their location. If this is the case the manager’s location would be listed as the J&J site location associated with the position. In some instances, these two locations may not match if the manager is hiring at a different location, e.g. a manger in the USA wanted to fill a position in Belgium. </p>
                        <p>So it is important to understand that the J&J site location associated with the position may differ from the actual location/office the employee will sit at (i.e. sales employees do not sit at the J&J site location regularly, nevertheless the location associated with the position is the J&J site location of the selected Legal Entity).</p>

                        {/* Question5 */}
                        <p id="Question5" className="faqQuestionHeader"><b>When was the data used by the tool last refreshed?</b></p>
                        <p>Location data was last refreshed on {this.state.locationLatestRefreshDate}. <br/>
                        Prefix Cost Center mapping data was last refreshed on {this.state.r360LatestRefreshDate}.<br/>
                        Financial Data Warehouse (FDW) data was last refreshed on {this.state.fwdLatestRefreshDate}. </p>

                        {/* Question6 */}
                        <p id="Question6" className="faqQuestionHeader"><b>How often is the data in the tool updated?</b></p>
						<p>Location data is updated once a week through Workday.
						Prefix cost center mapping is updated once a week through R360 LE-MRC-CC.
						Finance Data Warehouse (FDW) data used to generate the predictions is updated monthly.
						</p>

                        {/* Question7 */}
                        <p id="Question7" className="faqQuestionHeader"><b>Who can receive the Predictor Tool results via email?</b></p>
                        <p>All J&J employees, contractor, interns or co-ops with a valid J&J email address can receive the Predictor Tool results via email. <br/>
                        Note: A valid J&J email address is one with the domain “.jnj.com” e.g.  jalexa43@its.jnj.com  </p>

                        {/* Question8 */}
                        <p id="Question8" className="faqQuestionHeader"><b>What is the difference between Payroll and Headcount MRC and Cost Center?</b></p>
                        
                        <strong>Payroll MRC & Cost Center</strong><br/>
                        Where an employee is paid:
                        <ul style={{margin:"0"}}>
                            <li>When the employee receives a paycheck; the check is written from this MRC, and is recorded in this Cost Center.</li>
                        </ul>
                        <br/>
                        <strong>Headcount MRC & Cost Center</strong><br/>
                        Where an employee’s headcount and expenses are reported:
                        <ul style={{margin:"0"}}>
                            <li>This is the MRC and Cost Center who ultimately assumes the cost of the employee.</li>
                        </ul>
                        <p>Unless the Headcount MRC and Cost Center is specific the employee is assumed to be reported in the same MRC and Cost Center that he/she is paid in. </p>

                        {/* Question9 */}
                        <p id="Question9" className="faqQuestionHeader"><b>Helpful hints and features for selecting legal entity (LE) and cost center (CC).</b></p>
                        <p><strong>Legal Entity Page :</strong><span> Users are able to hover over ‘Associated MRC’ to see the management reporting companies (MRC)s attached to that legal entity (LE).</span></p>
                        <p><img className="faqImage" src={PTLEHoverFeature} alt=""/></p>
                        <p><strong>Cost Center Page :</strong><span> When selecting both payroll or headcount cost centers, users have the ability to expand a cost center listing and see the employees that fall under that cost center (at a particular level). </span></p>
                        <p><img className="faqImage" src={PTPayrollCCExpanded} alt=""/></p>
                        <p>Additionally, users have the ability to move one level up or down to see the employees within the organization that are also listed in that particular cost center. </p>
                        
                        <p><strong>Home Page :</strong><span> After typing in the Hiring Manager’s WWID the tool will pull up the location for that manager from Workday.  </span></p>
                        <p><img className="faqImage" src={PTManagerWWIDPopulated} alt=""/></p>
                        <p>This allows users to quickly input this information by typing directly into the location field. </p>
                        <p><img className="faqImage" src={PTLocationSearch} alt=""/></p>

                        {/* Question10 */}
                        <p id="Question10" className="faqQuestionHeader"><b>Predictor Tool pop-up descriptions.</b></p>
                        <p><strong>Popup #1</strong></p>
                        <p><img className="faqImage" src={PTLocationPopup} alt=""/></p>
                        <p><strong>Pop-up text:</strong></p>
                        <p>“The Selected Requisition Location and Hiring Manager’s Location do not match. Do you wish to continue?” </p>
                        <p><strong>When does pop-up occur?</strong></p>
                        <p>If the hiring manager’s location does not match with the J&J site location associated with position selected by the user. This would occur if the manager is not hiring or filling a position at their location e.g. a manager in USA hiring for a position in Belgium.</p>
                        <p><strong>Pop-up user selection actions.</strong></p>
                        <p>If ‘Yes’ is selected:</p>
                        <ul>
                            <li>User moves forward and is asked to select legal entity.</li>
                        </ul>
                        <p>If ‘No’ is selected:</p>
                        <ul>
                            <li>User will be sent back to the home page, where they can change the location before proceeding. </li>
                        </ul>
                        <p><strong>Popup #2</strong></p>
                        <p><img className="faqImage" src={PTHeadcountPopup} alt=""/></p>
                        <p><strong>Pop-up text:</strong></p>
                        <p>“Will the costs for this Position need to be accounted for in an organization different from the Position’s location (i.e. cross charged between Consumer US and Corporate US?)” </p>
                        <p><strong>When does pop-up occur?</strong></p>
                        <p>Popup appears after you select the Payroll Cost Center to determine whether or not Headcount MRC and CC are needed – if the cost of the position need to be accounted for in an organization different from the position’s location.</p>
                        <p><strong>Pop-up user selection actions.</strong></p>
                        <p>If ‘Yes’ is selected:</p>
                        <ul>
                            <li>User is prompted to select Headcount MRC followed by Headcount CC before being sent to the results page. </li>
                        </ul>
                        <p>If ‘No’ is selected:</p>
                        <ul>
                            <li>User will be sent straight to results page where they can copy and paste the information into their Workday Job Requisition or have the predictions emailed.</li>
                        </ul>
                    </div>
                </div>
            </div>
          );
      }
}
export default FrequentlyAsked;


